<template>
  <div class="lyItem" :class="bubbleSize">
    <div class="T1" :class="bubbleClass" :dir="data.direction || 'ltr'">
      <div class="t1Header" v-if="data.header">
        <box-element
          :uid="uid + '-head'"
          :data="data.header"/>
      </div>
      <div class="t1Hero" v-if="data.hero">
        <image-element :data="data.hero" v-if="data.hero.type === 'image'"/>
      </div>
      <div class="t1Body" :class="{'ExHasFooter': data.footer}" v-if="data.body">
        <box-element
          :uid="uid + '-body'"
          :data="data.body"/>
      </div>
      <div class="t1Footer" v-if="data.footer">
        <box-element
          :uid="uid + 'foot'"
          :data="data.footer"/>
      </div>
    </div>
  </div>
</template>
<script>
import vue from 'vue';
import BoxElement from './Element/BoxElement.vue';
import ImageElement from './Element/ImageElement.vue';

vue.component('box-element', BoxElement);

export default {
  name: 'flexBubbleLayout',
  components: {
    'image-element': ImageElement,
  },
  props: {
    data: {
      type: Object,
    },
    uid: {
      type: String,
      default: '',
    },
  },
  computed: {
    bubbleSize() {
      if (this.data && this.data.size) {
        switch (this.data.size) {
          case 'giga': return { LyGi: true };
          case 'kilo': return { LyKi: true };
          case 'micro': return { LyMi: true };
          case 'nano': return { LyNa: true };
          case 'mega': return { LyMe: true };
          default: return { LyMe: true };
        }
      }
      return {
        LyMe: true,
      };
    },
    bubbleClass() {
      if (this.data && this.data.direction) {
        if (this.data.direction === 'rtl') {
          return {
            fxRTL: true,
          };
        }
      }
      return {
        fxLTR: true,
      };
    },
    imageHeroClass() {
      if (this.data && this.data.hero && this.data.hero.type === 'image') {
        return {
          ExCover: this.data.hero.aspectMode === 'cover',
          MdImg: this.data.hero.type === 'image',
          ExFull: this.data.hero.size === 'full',
        };
      }
      return {};
    },
    imageHeroStyle() {
      if (this.data && this.data.hero && this.data.hero.type === 'image') {
        return {
          backgroundImage: `url('${this.data.hero.url}')`,
        };
      }
      return {};
    },
  },
};
</script>
